import { render, staticRenderFns } from "./unpermitted.vue?vue&type=template&id=3ea294f6&"
import script from "./unpermitted.vue?vue&type=script&lang=js&"
export * from "./unpermitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports